<app-button-export-to-excel 
    *ngIf="!loading && authorized"
    fileName="Committee Membership"
    [schema]="exportSchema" 
    [data]="data"
    id="btn-export-committee-membership"
    label="Export Members"
></app-button-export-to-excel>